import {AutocompleteModule, DatepickerModule, PaginationMapsModule} from "maps-angular-components";
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PaginationModule, TabsModule} from "ngx-bootstrap";

import {CarteiraModule} from "../carteira/carteira.module";
import { FeitoConferidoAcoesComponent } from './feito-conferido-acoes/feito-conferido-acoes.component';
import {FeitoConferidoComponent} from './feito-conferido.component';
import {FeitoConferidoPesquisaComponent} from './feito-conferido-pesquisa/feito-conferido-pesquisa.component';
import {FeitoConferidoService} from "./feito-conferido.service";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatTableModule} from "@angular/material/table";
import {NgModule} from '@angular/core';
import {NgStringPipesModule} from "ngx-pipes";
import {RegraModule} from "../regra/regra.module";
import {SharedModule} from "../shared/shared.module";

@NgModule({
  declarations: [FeitoConferidoPesquisaComponent, FeitoConferidoComponent, FeitoConferidoAcoesComponent],
    imports: [
        CommonModule,
        TabsModule,
        ReactiveFormsModule,
        CarteiraModule,
        MatRadioModule,
        RegraModule,
        SharedModule,
        DatepickerModule,
        MatSelectModule,
        MatDialogModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        PaginationMapsModule,
        PaginationModule,
        FormsModule,
        NgStringPipesModule,
        AutocompleteModule,
        MatCheckboxModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
  providers: [DatePipe, DecimalPipe, FeitoConferidoService],
  exports: [FeitoConferidoComponent],
})
export class FeitoConferidoModule {
}
